function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* eslint-disable */

/* ------------------------------------------------
Imports
------------------------------------------------ */

import gsap from 'gsap';
import { offset } from 'meteora';

/* ------------------------------------------------
The truck driving animation
------------------------------------------------ */

document.addEventListener('DOMContentLoaded', function () {
  var steps = _toConsumableArray(document.querySelectorAll('.steps-block'));
  steps.forEach(function (block) {
    var settings = {
      // The duration of the entire animation
      duration: 6,
      // The delay between each item animating
      delay: 0.3,
      // A boolean to control if the animation has already taken place
      hasAnimated: false,
      // timeout object
      timeout: {}
    };

    // create and array with all the steps items
    var items = _toConsumableArray(block.querySelectorAll('.steps-block-item'));

    // A function to sort the content into groups based on their x position
    var sortItems = function sortItems() {
      // Reset the content object
      var content = {};
      items.forEach(function (item) {
        var x = offset(item).x;
        // If content[x] is undefined, create it
        if (content[x] === undefined) content[x] = [];
        // Push the item to the content array
        content[x].push(item);
      });
      return content;
    };
    var track = document.createElement('div');
    var truck = document.createElement('img');
    track.classList.add('steps-block-track');
    truck.classList.add('steps-block-truck');
    truck.src = '/themes/mercury/source/images/standard/winstone-truck.png';

    // Add the track as the last child in the block
    block.insertBefore(track, block.lastElementChild);

    // add the truck to the track
    track.appendChild(truck);
    var play = function play() {
      // Get all the items grouped
      // const groups = sortItems();

      // clearTimeout(settings.timeout['play']);

      // settings.timeout['play'] = setTimeout(() => {
      // // We will loop through the groups and set an animation delay for each item in the group
      // Object.keys(groups).forEach((key, index) => {
      //   const group = groups[key];
      //   // The delay needs to be relative to the settings.duration and the number of groups
      //   // The duration each item in the group will animate for
      //   const duration = settings.duration / (Object.keys(groups).length * settings.delay);

      //   // Create a gsap timeline for each item in the group that makes it jiggle
      //   group.forEach((item) => {
      //     const timeline = gsap.timeline({ delay: index * settings.delay });

      //     timeline.to(item, {
      //       skewX: 10,
      //       duration: duration / 10,
      //       // bounce ease in out
      //       ease: 'power2.out',
      //       // ease: CustomEase.create("custom", "M0,0 C0,0 0.137,-0.015 0.154,0.2 0.16,0.287 0.187,0.647 0.196,0.734 0.203,0.803 0.207,0.839 0.216,0.908 0.222,0.962 0.226,0.991 0.236,1.044 0.243,1.086 0.247,1.109 0.257,1.15 0.264,1.179 0.271,1.197 0.281,1.225 0.284,1.234 0.287,1.24 0.292,1.248 0.296,1.256 0.3,1.26 0.306,1.266 0.309,1.27 0.314,1.273 0.319,1.275 0.323,1.277 0.328,1.278 0.334,1.277 0.339,1.277 0.344,1.275 0.349,1.272 0.355,1.268 0.36,1.265 0.365,1.259 0.377,1.246 0.385,1.24 0.395,1.225 0.428,1.177 0.429,1.17 0.462,1.121 0.478,1.097 0.488,1.083 0.507,1.062 0.524,1.043 0.535,1.034 0.554,1.018 0.563,1.01 0.57,1.007 0.58,1.001 0.59,0.996 0.594,0.992 0.605,0.989 0.62,0.984 0.631,0.981 0.647,0.979 0.663,0.977 0.674,0.976 0.692,0.977 0.78,0.983 0.759,0.992 0.85,0.998 0.894,1.001 0.905,1.001 0.95,1.001 0.982,1.001 1,1 1,1 "),
      //     });

      //     timeline.to(item, {
      //       skewX: 0,
      //       duration: duration / 2,
      //       // Elastic ease out
      //       ease: 'elastic.out(1.5, 0.75)',
      //     });
      //   });
      // });

      // gsap animate the truck from x 0% to x 100% of the track
      gsap.fromTo(truck, {
        left: 0,
        x: 0
      }, {
        left: '100%',
        x: '-100%',
        duration: settings.duration,
        // ease in
        ease: 'power2.inOut'
      });
      // }, 1500);

      // Lastly, set the hasAnimated to true so we don't run the animation again
      settings.hasAnimated = true;
    };

    // An intersection and resize observer to trigger sorting out the items into groups
    var observers = {
      resize: new ResizeObserver(function (entries) {
        return play();
      }),
      intersection: new IntersectionObserver(function (entries) {
        return play();
      })
    };

    // Observe the block
    observers['intersection'].observe(block);
    observers['resize'].observe(block);
  });
});